import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SidebarQuestionnaire from "../SidebarQuestionnaire";
import {
  fetchCategories,
  fetchQuestions,
  fetchSections,
  setSelectedCategory,
  setSelectedQuestion,
  setSelectedSection,
} from "../../../slices/Admin/survey-CSF.slice";

export default function CSFSidebar({
  selectedSurvey,
  isActiveSurvey,
  ...rest
}) {
  const dispatch = useDispatch();
  const {
    categories,
    selectedCategory,
    selectedSection,
    sections,
    submissionStatus,
  } = useSelector((state) => state.CSFSurvey);
  const selectedSurveyId = selectedSurvey?.csf_survey_id;

  // Trigger category fetch if not present
  useEffect(() => {
    if (isActiveSurvey) {
      if (!categories || categories.length === 0) {
        dispatch(fetchCategories(selectedSurveyId));
      } else {
        handleCategoryClick(selectedCategory);
      }
    }
  }, [categories, selectedSurveyId, isActiveSurvey]);

  useEffect(() => {
    //fetch section when category changes
    if (selectedCategory?.id) {
      dispatch(fetchSections({ categoryId: selectedCategory?.id }));
    }
  }, [selectedCategory?.id]);

  useEffect(() => {
    if (submissionStatus?.question_id) {
      dispatch(
        fetchSections({
          categoryId: selectedCategory?.id,
          fromSubmission: true,
        })
      );
      dispatch(
        fetchQuestions({
          sectionId: selectedSection?.id,
          preSubId: selectedSurveyId,
          fromSubmission: true,
        })
      );
    }
  }, [submissionStatus]);

  const handleCategoryClick = (category) =>
    dispatch(setSelectedCategory(category));

  const handleSectionClick = (section) => dispatch(setSelectedSection(section));

  const handleQuestionClick = (question) =>
    dispatch(setSelectedQuestion(question));

  return (
    <SidebarQuestionnaire
      domains={categories}
      goalsData={sections}
      selectedDomainIndex={selectedCategory?.id}
      selectedGoalID={selectedSection?.id}
      handleGoalClick={handleSectionClick}
      handleDomainClick={handleCategoryClick}
      handleQuestionClick={handleQuestionClick}
      selectedSurvey={selectedSurvey}
      assessmentName="CSF 2.0 Pre-Assessment"
      isActiveSurvey={isActiveSurvey}
      {...rest}
    />
  );
}
